@if (gridOptions) {
  <dv-grid [actions]="actions()">
    <ag-grid-angular
      dvPinSelectedRow
      vtGridRowEditing
      [entity]="entity.AssetDocument"
      [entityId]="$safeNavigationMigration(selectedNode?.id)"
      class="ag-theme-devinco"
      (selectionChanged)="onSelectionChanged($event)"
      (toolPanelVisibleChanged)="toolPanelVisibilityChanged($event)"
      (gridReady)="onGridReady($event)"
      (modelUpdated)="onModelUpdated($event)"
      [gridOptions]="gridOptions">
    </ag-grid-angular>
  </dv-grid>
  <div></div>
}
